import { ProviderSignUpBanner as CoreProviderSignUpBanner } from '@care/provider-react-components';
import { useState, useMemo, useEffect } from 'react';
import getConfig from 'next/config';
import Cookies from 'universal-cookie';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';

export interface ProviderSignUpBannerProps {
  learnMoreUrl?: string;
}

export const PROVIDER_SIGN_UP_BANNER_COOKIE_KEY = 'providerSignUpBannerDismissed';
export const TIME_TO_LIVE = 60 * 60 * 24; // 1 day

export const ProviderSignUpBanner = ({ learnMoreUrl }: ProviderSignUpBannerProps) => {
  const cookies = useMemo(() => new Cookies(), []);
  const { publicRuntimeConfig } = getConfig();
  const currentDomain = publicRuntimeConfig.NEXT_PUBLIC_APP_URL ?? '';
  const defaultSignupUrl = `${currentDomain}/explore/joinus?source=marketplace`;
  const finalLearnMoreUrl = learnMoreUrl ?? defaultSignupUrl;
  const [isBannerVisible, setIsBannerVisible] = useState<boolean>(true);

  useEffect(() => {
    trackAmplitudeEvent(AmplitudeEvent.lybBannerShown);
  }, []);

  const handleBannerClose = () => {
    trackAmplitudeEvent(AmplitudeEvent.lybBannerClosed);
    cookies.set(PROVIDER_SIGN_UP_BANNER_COOKIE_KEY, 'true', { path: '/', maxAge: TIME_TO_LIVE });
    setIsBannerVisible(false);
  };

  const handleLearnMoreClick = () => {
    trackAmplitudeEvent(AmplitudeEvent.ctaInteracted, {
      cta_text: 'Learn More',
      cta_type: 'List Your Business Banner',
    });
    cookies.set(PROVIDER_SIGN_UP_BANNER_COOKIE_KEY, 'true', { path: '/', maxAge: TIME_TO_LIVE });
    setIsBannerVisible(false);
    globalThis.open(finalLearnMoreUrl, '_blank');
  };

  return isBannerVisible ? (
    <CoreProviderSignUpBanner onClose={handleBannerClose} onAction={handleLearnMoreClick} />
  ) : null;
};
